import React from 'react';
import { RouteObject } from 'react-router-dom';

import NotFoundPage from 'src/components/NotFoundPage/NotFoundPage';
import ExtractOverview from './pages/ExtractOverview';
import ExtractGoals from './pages/ExtractGoals';
import ExtractGoalAccomplishment from './pages/ExtractGoalAccomplishment';
import ExtractIdeasAndCompanies from './pages/ExtractIdeasAndCompanies';
import ExtractKtu from './pages/ExtractKtu';

const routes: RouteObject[] = [
  {
    path: '',
    index: true,
    element: <ExtractOverview />,
  },
  {
    path: ``,
    element: <ExtractOverview />,
  },
  {
    path: `/goals`,
    element: <ExtractGoals />,
    handle: { crumbs: ['targetNumber'] },
  },
  {
    path: `/goalaccomplishment`,
    element: <ExtractGoalAccomplishment />,
    handle: { crumbs: ['company.details.sidenav.GoalAchievement'] },
  },
  {
    path: `/ideas-and-companies`,
    element: <ExtractIdeasAndCompanies />,
    handle: { crumbs: ['ideasAndCompanies.title'] },
  },
  {
    path: `/ktu`,
    element: <ExtractKtu />,
    handle: { crumbs: ['export.ktu.header'] },
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
